<script>
export default {
    data() {
        return {
            view: { 
                name: 'table',
                description: 'The <span class="pink-text">Table View</span>  is the best choice for anyone used to working in Excel, Google Sheets, or CRM as it gives you a condensed view of all data, formulas, etc.'
            },
            views: [
                { 
                    name: 'table',
                    description: 'The <span class="pink-text">Table View</span> is the best choice for anyone used to working in Excel, Google Sheets, or CRM as it gives you a condensed view of all data, formulas, etc.'
                },
                { 
                    name: 'column',
                    description: 'The <span class="pink-text"> Columns View </span>  is ideal for people who want to track their tasks, projects, and progress in a more visual way, and have all items displayed at a glance.'
                },
                { 
                    name: 'list',
                    description: 'The <span class="pink-text"> List View </span>  is perfect for you if you’re mostly dealing with to-do lists and need a straightforward view of your tasks. Gives you a quick overview of all tasks.'
                },
                { 
                    name: 'calendar',
                    description: 'The <span class="pink-text"> Calendar View </span>  will help you organize and manage any time-sensitive items you might be working with, including meetings, events, and important dates.'
                },
                { 
                    name: 'gantt',
                    description: 'The <span class="pink-text"> Gantt View </span>  will let you create and visualize timelines for long-term projects, as well as capture start and end dates in one simple view. Ideal for project planning.'
                },
                { 
                    name: 'form',
                    description: 'The <span class="pink-text"> Form View </span>  allows you to create custom forms, share them with anyone you want via a link, or embed them on your website to collect data straight into Infinity.'
                },
            ],
        };
    },
    methods:{
        goToStep(view)
        {
            this.view = view;
        }
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/frontend/components/ViewsImagesSlider.vue